import fixedoddsbetting from './FixedOddsBetting'
import ganwallet from './GanWallet'
import customlogin from './CustomLogin'
import fanduelwallet from './FanduelWallet'
import igtcommand from './IGTCommand'
import playshot from './PlayShot'
import user from './User'
import xpbetting from './XPBetting'
import buyback from './BuyBack'
import tokens from './Tokens'
import auth from './Auth'
import gns from './GamingNotificationService'
import geocomply from './GeocomplyService'
import account from './Account'
import iw from './IW'
import tote from './Tote'
import totp from './Totp'
import playerfavorites from './PlayerFavorites'
import contests from './Contests'
import utility from './Utility'
import wishbetclient from './WishBetClient'

export default {
  fixedoddsbetting,
  ganwallet,
  customlogin,
  fanduelwallet,
  igtcommand,
  playshot,
  user,
  xpbetting,
  buyback,
  tokens,
  auth,
  gns,
  geocomply,
  account,
  iw,
  tote,
  totp,
  playerfavorites,
  contests,
  utility,
  wishbetclient
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/index.js